// filepath: e:\eMaterai-landingPage\gatsby-browser.js
import './src/global.css';

// export const wrapRootElement = Root;
